export const ContactType = {
  Voice: 'voice',
  QueueCallback: 'queue_callback',
  Chat: 'chat',
  Task: 'task',
};

export const InitiationMethod = {
  Outbound: 'outbound',
  Inbound: 'inbound',
  Transfer: 'transfer',
  Callback: 'callback',
  QueueTransfer: 'queue_transfer',
  Api: 'api',
};

export const Status = {
  Connecting: 'connecting',
  Error: 'error',
  Ended: 'ended',
  Init: 'init',
  Incoming: 'incoming',
  Pending: 'pending',
  Connected: 'connected',
  Missed: 'missed',
  Rejected: 'rejected',
  Paused: 'paused',
};

export const TaskType = {
  BgmHyperAlert: 'BGM_HYPER_ALERT',
  BgmHypoAlert: 'BGM_HYPO_ALERT',
  BgmHypoAlert2: 'BGM_HYPO_ALERT_2',
  BgmHypoAlert3: 'BGM_HYPO_ALERT_3',
};
